module.exports = __webpack_public_path__ + "img/UI_common_title_help_012_ed6f54aa3.png";